import { render, staticRenderFns } from "./TipoContactoModalEdicion.vue?vue&type=template&id=3a716815&scoped=true&"
import script from "./TipoContactoModalEdicion.vue?vue&type=script&lang=ts&"
export * from "./TipoContactoModalEdicion.vue?vue&type=script&lang=ts&"
import style0 from "./TipoContactoModalEdicion.vue?vue&type=style&index=0&id=3a716815&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a716815",
  null
  
)

export default component.exports